import { render, staticRenderFns } from "./YouTubeModal.vue?vue&type=template&id=3ba7e16d"
import script from "./YouTubeModal.vue?vue&type=script&lang=ts"
export * from "./YouTubeModal.vue?vue&type=script&lang=ts"
import style0 from "./YouTubeModal.vue?vue&type=style&index=0&id=3ba7e16d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports